import React from 'react';
import { motion } from 'framer-motion';
import { SiblingFigure } from './characters/SiblingFigure';
import { siblings } from '../data/siblings';
import type { SiblingRole } from '../types/snak';
interface SiblingGuessRowProps {
  guess: SiblingRole | null;
  onGuess: (role: SiblingRole) => void;
}
export function SiblingGuessRow({
  guess,
  onGuess
}: SiblingGuessRowProps) {
  return <div className="grid grid-cols-2 gap-2.5" data-id="element-241" data-mp="70wo3azccxrz">
      {siblings.map((sibling, i) => {
      const isGuess = guess === sibling.id;
      return <motion.button key={sibling.id} type="button" onClick={() => onGuess(sibling.id)} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: guess && !isGuess ? 0.4 : 1,
        y: 0
      }} transition={{
        delay: guess ? 0 : 0.1 + i * 0.06,
        duration: 0.4,
        ease: 'easeOut'
      }} whileTap={{
        scale: 0.96
      }} className={['flex items-center gap-2 rounded-2xl px-3 py-2.5 text-left transition-colors', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary', isGuess ? 'bg-white text-background' : 'bg-white/[0.08] text-white ring-1 ring-white/15 hover:bg-white/[0.14]'].join(' ')} aria-pressed={isGuess} data-id="element-242" data-mp="by6o1kkcwru2" data-mpi={i}>
            <span className="flex h-10 w-10 shrink-0 items-end justify-center overflow-hidden rounded-full" style={{
          backgroundColor: sibling.surface
        }} data-id="element-243" data-mp="3iy3e7yidkcyj">
              <SiblingFigure role={sibling.id} className="h-[46px] w-auto translate-y-[3px]" data-id="element-244" data-mp="3a5rpch2wsxko" />
            </span>
            <span className="font-body text-[13px] leading-tight" data-id="element-245" data-mp="357gh2as9iv4k">{sibling.label}</span>
          </motion.button>;
    })}
    </div>;
}